/**
 * CUSTOMERS (abbreviation):- CUST
 */
export const CUST_UPDATE_STATE = "CUST_UPDATE_STATE"
export const CUST_UPDATE_CUSTOMER_PROFILE = "CUST_UPDATE_CUSTOMER_PROFILE"
export const CUST_UPDATE_SELECTED_CHATLOG = "CUST_UPDATE_SELECTED_CHATLOG"
export const CUST_MORE_CHATLOGS_LOADED = "CUST_MORE_CHATLOGS_LOADED"
export const CUST_UPDATE_SELCECTED_CHAT_MESSAGE = "CUST_UPDATE_SELCECTED_CHAT_MESSAGE"
export const CUST_UPDATE_CHATLIST_ITEM = "CUST_UPDATE_CHATLIST_ITEM"
